// extracted by mini-css-extract-plugin
module.exports = {"informationFirst":"Steps_informationFirst__2kNif","informationSecond":"Steps_informationSecond__2nq1u"};